<div
  *ngIf="state.renderTooltip && state.activeTooltipParentRef; else tooltipContent"
  [id]="state.activeTooltipParentRef"
  santaTooltip
  [hideOnScroll]="false"
  [controlledByParent]="true"
  [tooltipContent]="tooltipTemplate"
  [opened]="state.showTooltip"
  [disableTooltip]="state.isClickedOutside || !state.isInView"
  [tooltipAdditionalOffset]="state.offset"
  [tooltipPosition]="tooltipPosition"
  allianceIntersectionObserver
  intersectionThreshold="1"
  (allianceIntersectionObservee)="setInViewState($event)"
  class="santa-inline-flex"
  (click)="onClicked()"
>
  <ng-container *ngTemplateOutlet="tooltipContent"></ng-container>
</div>

<ng-template #tooltipContent>
  <div class="santa-inline-flex">
    <ng-content></ng-content>
  </div>
</ng-template>
